import React from "react";
import Select from "react-select";
import { Button } from "aible";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { LineInput } from "components/Inputs/LineInput";

import Logo from "images/logo1.png";
import azureIcon from "images/logo-azure.svg";
import BoomiIcon from "images/boomi.svg";

import styles from "./style.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

export default class Redirect extends React.PureComponent {
  componentDidMount() {
    const { handleRedirect, domainRedirect } = this.props;
    return setTimeout(() => handleRedirect(domainRedirect), 4000);
  }

  render() {
    const { domainRedirect, isDellDomain } = this.props;

    return (
      <div className={styles.body}>
        <div className={styles.loginBox}>
          <div className={styles.loginHeader}>
            <div className={styles.name}>
              <img className={styles.logoImage} src={Logo} />
            </div>
          </div>
          <div className={styles.loginContent}>
            <div className={styles.logoHolder}>
              <div className={styles.logoTitle}>{"In partnership with"}</div>
              <div className={styles.loginLogo}>
                <img src={BoomiIcon} alt={"Boomi Logo"} />
              </div>
            </div>
            <div className={styles.redirectHolder}>
              <div className={styles.redirectMessage}>{"Redirecting you to the Aible login page..."}</div>
            </div>
            <LoadingIndicator />
            <div className={styles.redirectLink}>
              <span>{"Go there now: "}</span>
              <a href={domainRedirect}>{domainRedirect}</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
